export const COLOR_VISION_MODES = ['standard', 'red-green', 'blue-yellow'];
export function isColorVisionMode(value) {
    return typeof value === 'string' && COLOR_VISION_MODES.includes(value);
}
// Tuned per theme: each theme has its own background and accent colours, so
// one palette cannot sit right on all six.
const OVERRIDES = {
    'red-green': {
        'industrial-laser': { success: '#2DD4BF', warning: '#FFC247', error: '#FF4D4D', info: '#1E8FFF' },
        'backstage-synth': { success: '#2DD4BF', warning: '#FFC247', error: '#FF4F64', info: '#A78BFA' },
        'vhs-control-room': { success: '#27E6D6', warning: '#FFC247', error: '#FF5C5C', info: '#8B5CF6' },
        'rigging-bay': { success: '#3AA7FF', warning: '#FFC247', error: '#F05A5A', info: '#8B95A3' },
        'classic-light': { success: '#0E8388', warning: '#E0962A', error: '#D64545', info: '#6366F1' },
        'chauvet-corporate': { success: '#0E8388', warning: '#D99A1E', error: '#C62828', info: '#007AC2' },
    },
    'blue-yellow': {
        'industrial-laser': { success: '#41FF8A', warning: '#FF9E57', error: '#E0303A', info: '#9AA4B2' },
        'backstage-synth': { success: '#41FF8A', warning: '#FF9E57', error: '#FF3B5C', info: '#9AA4B2' },
        'vhs-control-room': { success: '#4ADE80', warning: '#FF9E57', error: '#F03C3C', info: '#9AA4B2' },
        'rigging-bay': { success: '#4ADE80', warning: '#FF9E57', error: '#E53935', info: '#8B95A3' },
        'classic-light': { success: '#15803D', warning: '#EA7317', error: '#B91C1C', info: '#64748B' },
        'chauvet-corporate': { success: '#0F7A52', warning: '#E07B1A', error: '#B3261E', info: '#64748B' },
    },
};
/** The theme with its state colours swapped for the given mode. */
export function withColorVision(def, mode) {
    if (mode === 'standard')
        return def;
    const state = OVERRIDES[mode][def.id];
    return state ? { ...def, tokens: { ...def.tokens, state } } : def;
}
//# sourceMappingURL=colorVision.js.map